import React, { useState } from "react";
import { Button } from "reactstrap";
import AddMonthlyParkingSubscriptionModal from "./AddMonthlyParkingSubscriptionModal";

const AddMonthlyParkingSubscription = ({ orders, reloadTime }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    return (
        <>
            <Button
                className="button-gradient-bg"
                onClick={toggleModal}
            >
                Add Subscription
            </Button>

            <AddMonthlyParkingSubscriptionModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                orders={orders}
                reloadTime={reloadTime}
                handleSave={reloadTime}
            />
        </>
    );
};

export default AddMonthlyParkingSubscription;